export const variantItems = [
  {
    title: 'Orders',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/orders-new.svg',
    cardImageTitle: 'Orders',
    cardImageAltTxt: 'Orders icon of a calendar invite',
    untransformedUrl: '/order-center/orders',
    externalLink: false,
    url: '/order-center/orders',
  },
  {
    title: 'Quotes',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/quotes.svg',
    cardImageTitle: 'Quotes',
    cardImageAltTxt: 'Quote Icon of a price tag',
    untransformedUrl: '/order-center/quotes',
    externalLink: false,
    url: '/order-center/quotes.html',
  },
  {
    title: 'Quick Order',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/quick-order-new.svg',
    cardImageTitle: 'Quick Order',
    cardImageAltTxt: 'Quick Order Icon',
    untransformedUrl: '/quick-order',
    externalLink: false,
    url: '/quick-order',
  },
  {
    title: 'Oligos & qPCR Probes',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/oligos-new.svg',
    cardImageTitle: 'Oligos, qPCR Probes & Peptides',
    cardImageAltTxt: 'Oligos, qPCR Probes & Peptides Icon',
    untransformedUrl:
      '/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes',
    externalLink: false,
    url: '/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes',
  },
  {
    title: 'Invoices',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/invoices-new.svg',
    cardImageTitle: 'Invoices',
    cardImageAltTxt: 'Invoices Icon',
    untransformedUrl: '/order-center/invoice-list',
    externalLink: false,
    url: '/order-center/invoice-list',
  },
  {
    title: 'Document Library',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/document-library-new.svg',
    cardImageTitle: 'Document Library',
    cardImageAltTxt: 'Document Library Icon',
    untransformedUrl: '/docs',
    externalLink: false,
    url: '/docs',
  },
  {
    title: 'Saved Carts',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/saved-carts.svg',
    cardImageTitle: 'Saved Carts',
    cardImageAltTxt: 'Saved cart icon of a shopping carat',
    untransformedUrl: '/order-center/saved-carts',
    externalLink: false,
    url: '/order-center/saved-carts.html',
  },
  {
    title: 'Account',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/account.svg',
    cardImageTitle: 'Account',
    cardImageAltTxt: "Account icon of an outline of a person's head",
    untransformedUrl: '/order-center/account',
    externalLink: false,
    url: '/order-center/account.html',
  },
  {
    title: 'Support',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/support.svg',
    cardImageTitle: 'Support',
    cardImageAltTxt: 'Support icon of a headset',
    untransformedUrl: '/US/en/support/customer-support',
    externalLink: false,
    url: '/US/en/support/customer-support',
  },
  {
    title: 'Lists',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/lists.svg',
    cardImageTitle: 'Lists',
    cardImageAltTxt: 'List icon of a list with plus sign',
    untransformedUrl: '/order-center/lists',
    externalLink: false,
    url: '/order-center/lists.html',
  },
  {
    title: 'Buy It Again',
    cardImageReference:
      '/deepweb/assets/sigmaaldrich/marketing/global/images/icons/buy-it-again-new.svg',
    cardImageTitle: 'Buy It Again',
    cardImageAltTxt: 'Buy It Again icon',
    untransformedUrl: '/order-center/buy-it-again',
    externalLink: false,
    url: '/order-center/buy-it-again',
  },
]
